/* This file is autogenerated, see readme.md for instructions */
import TagSvgIcon from '@bloomreach/banana-theme/icons/tag.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const TagIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <TagSvgIcon />
    </Icon>
  );
});

TagIcon.displayName = 'TagIcon';

export default TagIcon;
